<template>
  <div id="twitch-embed"></div>
</template>

<script>
export default {
  props: {
    channel: {
      type: String,
      default: "splinti",
    },
    width: {
      type: Number,
      default: 854,
    },
    height: {
      type: Number,
      default: 480,
    },
    parent: {
      type: Array,
      default: () => [
        "splinti.de",
        "localhost",
        "splinti-de.vserv2.splinti.de",
      ],
    },
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://embed.twitch.tv/embed/v1.js";
    script.addEventListener("load", () => {
      // eslint-disable-next-line no-undef
      new Twitch.Embed("twitch-embed", {
        width: this.width,
        height: this.height,
        channel: this.channel,
        parent: this.parent,
      });
    });
    document.body.appendChild(script);
  },
};
</script>
